class HvHeaderMenu extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.bindSubmenuTriggers();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  bindSubmenuTriggers() {
    const { signal } = this.abortController;

    const getMenuItem = (event) => {
      const item = event.target.closest('li.menu-item-has-children');
      if (!item || !this.contains(item)) return null;
      return item;
    };

    const getTrigger = (item) => item.querySelector(':scope > a[aria-controls]');

    const loadDeferredMedia = (panel) => {
      if (!panel || panel.dataset.mediaLoaded === 'true') return;
      panel.dataset.mediaLoaded = 'true';
      panel.querySelectorAll('[data-src], [data-srcset]').forEach((element) => {
        if (element.dataset.src && !element.getAttribute('src')) element.src = element.dataset.src;
        if (element.dataset.srcset && !element.getAttribute('srcset')) element.srcset = element.dataset.srcset;
        element.removeAttribute('loading');
      });
    };

    const setExpanded = (trigger, isExpanded) => {
      if (!trigger) return;
      trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      if (isExpanded) {
        loadDeferredMedia(document.getElementById(trigger.getAttribute('aria-controls')));
      }
    };

    this.addEventListener(
      'mouseover',
      (event) => {
        const item = getMenuItem(event);
        if (!item || item.contains(event.relatedTarget)) return;
        setExpanded(getTrigger(item), true);
      },
      { signal }
    );

    this.addEventListener(
      'mouseout',
      (event) => {
        const item = getMenuItem(event);
        if (!item || item.contains(event.relatedTarget)) return;
        setExpanded(getTrigger(item), false);
      },
      { signal }
    );

    this.addEventListener(
      'focusin',
      (event) => {
        const item = getMenuItem(event);
        if (!item) return;
        setExpanded(getTrigger(item), true);
      },
      { signal }
    );

    this.addEventListener(
      'focusout',
      (event) => {
        const item = getMenuItem(event);
        if (!item || item.contains(event.relatedTarget)) return;
        setExpanded(getTrigger(item), false);
      },
      { signal }
    );
  }
}

if (!customElements.get('hv-header-menu')) {
  customElements.define('hv-header-menu', HvHeaderMenu);
}
